export const StubbedImageData = [
  {
    url: 'https://az712897.vo.msecnd.net/images/full/0bf9d846-d0c1-4660-a9e6-c2c6d3f1c18b.jpeg',
    description: 'Featured Image',
  },
  {
    url: 'https://az712897.vo.msecnd.net/images/full/8eb0aa4c-2ec2-4864-b9df-8a1cfa4f2f20.jpeg',
    description: 'Guestroom',
  },
  {
    url: 'https://az712897.vo.msecnd.net/images/full/29b4cbd1-e32e-4928-a2d6-ca729f48bdd8.jpeg',
    description: 'Guestroom',
  },
  {
    url: 'https://az712897.vo.msecnd.net/images/full/28128cf9-e1b9-4c2a-a8fd-f35dc1a7a9c9.jpeg',
    description: 'Room',
  },
  {
    url: 'https://az712897.vo.msecnd.net/images/full/3c071871-26cf-4678-8e25-19950b3378bf.jpeg',
    description: 'Room',
  },
  {
    url: 'https://az712897.vo.msecnd.net/images/full/3a21cbd8-fb80-4a31-8863-7cb44cc0f08f.jpeg',
    description: 'Living Area',
  },
];
